export default "__VITE_ASSET__CqOpnOQI__"